import { HeaderFieldCellMixins, FieldCellMixins } from './mixins.js';

const TextFieldCell = {
  mixins: [FieldCellMixins],

  template: `
    <div v-html="formattedValue"
         :title='text_value'
         class="text-ellipsis">
    </div>
  `,

  computed: {
    formattedValue: function() {
      return Skylark.Helpers.UrlHelper.wrapRawLink(this.text_value);
    }
  }
};

const TextFieldHeaderCell = {
  mixins: [HeaderFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="input-control left-addon">
          <input type="text"
                 class='controlled-input bordered'
                 placeholder='搜索'
                 v-model.trim='keyword'
                 @keyup.enter='updateFilter' />
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
      </div>
      <div class="sort-option-container list" v-if="hasSort">
        <div class="list-item"
             v-for="sort in sortable"
             @click='toggleSort(sort)'
             :key='sort'>
          <div class="content">{{ Skylark.Helpers.getZH_CN('sort.' + sort) }}排列</div>
          <div class="tip" v-if='sorter === sort'>
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
    </div>
  `
};

export { TextFieldCell, TextFieldHeaderCell };
